import React from 'react'
import { connect } from "react-redux"
import { withRouter } from 'react-router'
import { setTitle } from "../../actions"


import Swiper from 'react-id-swiper';
import  './styles/onboardStyles.scss';


import Group70 from './images/group70';
import Group71 from './images/group71';
import Group69 from './images/group69';
import Group72 from './images/group73';
import Group74 from './images/group74';

@connect((store) => {
	return { User: store.User.User, app: store.app, practices: store.practices }
})

class TherapistOnboarding extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			firstTime: false
		}
		this.goNext = this.goNext.bind(this)
		this.swiper = null
	}

	goNext() {
		if (this.swiper) this.swiper.slideNext();
		if(this.swiper.isEnd){
			document.body.classList.toggle('lastSlide');
		}
	}

	componentDidMount() {
		this.checkFirstTime()
		this.toggleClassOnboarding();
	}

	checkFirstTime() {

		var url_string = window.location.href;
		var url = new URL(url_string);

		this.setState({
			firstTime:(url.searchParams.has('nav')) ? false : true
		})
	}

	componentWillUnmount(){
		this.toggleClassOnboarding();
		document.body.classList.toggle('lastSlide');
	}

	toggleClassOnboarding(){
		document.body.classList.toggle('onboarding');
	}

	toggleRedirect() {

		var newUrl = '/home';
		var url_string = window.location.href;
		var url = new URL(url_string);

		if(url.searchParams.has('redirect')) {
			newUrl = (url.searchParams.has('redirect')) ? url.searchParams.get('redirect'): '/home';
		}

		return newUrl
	}

	render() {
		const swiperParams = {
			slidesPerView: 1,
			pagination: {
			  el: '.swiper-pagination',
			  clickable: true,
			},
			spaceBetween: 10,
			observer: true,
			observeParents: true,
			noSwiping: true,
			noSwipingClass: 'swiper-slide'
		  }
		return (
			<main id="therapistOnboarding">
				
				<Swiper {...swiperParams} ref={node => this.swiper = node !== null ? node.swiper : null }>
					<div className="slide slide1">
						<div className="content">
							<Group70/>
							<p>Click on the specific practice URL provided by the practice owner. <br className="noBreakMobile"/> Log in & click on the join practice button.</p>
						</div>
					</div>
					<div className="slide slide2">
						<div className="content">
							<Group71/>
							<p>You now need to save the page to your home screen - we will send you <br className="noBreakMobile"/> support for an iPhone and a Samsung.</p>
						</div>
					</div>
					<div className="slide slide3">
						<div className="content">
							<Group69/>
							<p>Once you have been assigned as a therapist your patients will be assigned to you.<br className="noBreakMobile"/>  You will then be able to view their names on your home page. <br className="noBreakMobile"/> Click on the patients name. This is where you can edit the patients profile.</p>
						</div>
					</div>
					<div className="slide slide4">
						<div className="content">
						<Group72/>
							<p>Click on add assessment. Add internal and parent notes,<br className="noBreakMobile"/>  select therapy areas and upload documents.</p>
						</div>
					</div>
					<div className="slide slide5">
						<div className="content">
						<Group74/>
							<p>You can then add sessions by clicking on the plus button.<br className="noBreakMobile"/>  You can create notes, patients will only view the sessions once you click send. <br className="noBreakMobile"/> Once you send the notes they can not be edited.</p>
						</div>
					</div>
				</Swiper>
					<div className="buttonGroup">
						<div className="skipButton">
							<a href={this.toggleRedirect()}>SKIP</a>
						</div>
						<div className="nextButton">
							<a onClick={this.goNext}>NEXT</a>
						</div>
						{this.state.firstTime ?
						<div className="letsStartButton">
							<a href={this.toggleRedirect()}>LET'S START</a>
						</div>
						:
						<div className="letsStartButton">
							<a href="/home">CLOSE</a>
						</div>
						}
					</div>
			
			</main>
		)
	}

}

export default withRouter(TherapistOnboarding)


// WEBPACK FOOTER //
// ./src/components/onboarding/TherapistOnboarding.jsx